import { Button, Popover } from "flowbite-react";
import React from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useUserServices } from "../context/DealerProfile";

const OrderListActionButton = ({ order }) => {
  const {
    dealerDetail: { parentAccount },
    priceItem,
  } = useUserServices();
  const { Stage } = order ?? {};
  const navigate = useNavigate();

  // console.log({ priceItem });

  const handleRepeadOrder = async () => {
    const loadingToast = toast.loading("Prepairing Your Order...");
    try {
      const res = await fetch(`/server/dealer_backend/order/${order?.id}`);
      if (!res.ok) {
        throw new Error("Failed to fetch");
      }
      const data = await res.json();
      const orderDetails = data?.data;
      const { Orders_Items } = orderDetails;

      // Fetch detailed information for each order item
      const detailedOrderItems = await Promise.all(
        Orders_Items.map(async (item) => {
          try {
            const response = await fetch(
              `/server/dealer_backend/item/${item.Product_Name.id}`
            );
            const { status, data } = await response.json();
            if (status === "success" && data) {
              return {
                id: data.id,
                Product_Code: data.Product_Code,
                Product_Name: data.Product_Name,
                Quantity: item.Quantity,
                Unit_Price: data.Unit_Price,
                Distributors_Discount_Price: (
                  data.Unit_Price -
                  (data.Unit_Price * parentAccount?.Price_Tier2) / 100
                ).toFixed(2),
                // Distributors_Discount_Price: data.Distributors_Discount_Price,
                Usage_Unit: data.Usage_Unit,
                Description: data.Description,
                Minimum_Order_level: data.Minimum_Order_level,
                Record_Image: data.Record_Image,
                Product_Type: data.Product_Type,
                Book_Id: data.Book_Id,
                Sub_Category_B: data.Sub_Category_B,
                Weight: data.Weight,
                Karam_No: data.Karam_No,
                Dimensions: data.Dimensions,
                HS_Code: data.HS_Code,
              };
            } else {
              console.warn(
                `Failed to fetch details for item ID: ${item.Product_Name.id}`
              );
              return null;
            }
          } catch (error) {
            console.error(
              `Error fetching details for item ID: ${item.Product_Name.id}`,
              error
            );
            return null;
          }
        })
      );

      // Map and merge price information dynamically
      const detailedOrderItemsWithPrice = detailedOrderItems.map((item) => {
        if (!item) return null; // Skip null items
        const priceInfo = priceItem?.find(
          (price) => price.item_id === item.Book_Id
        );
        return {
          ...item,
          Distributors_Discount_Price:
            priceInfo?.pricebook_rate || item.Distributors_Discount_Price,
        };
      });

      // Filter out items that failed to fetch
      const validOrderItems = detailedOrderItemsWithPrice.filter(
        (item) => item !== null
      );

      if (validOrderItems.length === 0) {
        throw new Error("No valid order items could be prepared.");
      }

      // Prepare the data for the new order form
      const editedOrderData = {
        Dealer_Name: orderDetails?.Dealer_Name.name,
        Delivery_Date: orderDetails?.Delivery_Date,
        CP_Purchase_Owner: orderDetails?.Owner.name,
        Date: orderDetails.Date,
        Stage: "Draft", // Reset stage to Draft for the new order
        Contact: orderDetails?.Contact?.id,
        Orders_Items: validOrderItems, // Use detailed order items here
        billingAddresses: orderDetails.Billing_Address_Link?.id,
        whichTypeShipping: "in", // Set default or determine from original order
        inHouseShipping: orderDetails.Shipping_Address_Link?.id,
      };

      // Store the prepared data
      localStorage.setItem("current_purchase", JSON.stringify(editedOrderData));
      toast.dismiss(loadingToast);
      toast.success("Order ready for editing");

      // Navigate to the new order form
      navigate("/purchase-order/new");
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error("Failed to prepare order for editing");
      console.error("Edit order error:", error);
    }
  };

  const handleCancelOrder = () => {
    console.log({ order });
    navigate(`/cancel-order/${order.id}-${encodeURIComponent(order?.Name)}`);
  };

  const handleReturnOrder = async () => {
    navigate("/sales-return/" + order.id);
  };

  const content = (
    <div className="text-sm text-gray-500 dark:text-gray-400">
      <div className="border-b border-gray-200 bg-gray-100 px-3 py-2 dark:border-gray-600 dark:bg-gray-700">
        <h3 className="font-semibold text-gray-900 dark:text-white">Action</h3>
      </div>
      <div className="px-3 py-2 flex gap-y-3 flex-col">
        {Stage?.endsWith("Invoiced") ? (
          <>
            <Button size="xs" color="dark" onClick={handleReturnOrder}>
              Sales Return
            </Button>
            <Button size="xs" color="dark" onClick={handleRepeadOrder}>
              Repeat Order
            </Button>
          </>
        ) : (
          <>
            <Button size="xs" color="dark" onClick={handleRepeadOrder}>
              Repeat Order
            </Button>

            {Stage !== "Void" && (
              <Button size="xs" color="dark" onClick={handleCancelOrder}>
                Cancel Request
              </Button>
            )}
          </>
          // <span>No Actions</span>
        )}
      </div>
    </div>
  );

  return (
    <div className="mx-auto place-items-center">
      <Popover content={content} trigger="click">
        <Button className="font-bold" size="xs" color="gray" outline>
          :
        </Button>
      </Popover>
    </div>
  );
};

export default OrderListActionButton;
